import { AuthGuardService } from '../services/auth-guard.service';
import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmailTemplatesListComponent } from './email.templates.list/email.templates.list.component'

const EmailTemplatesRouting: Routes = [
    // login view
    {
        path: 'email-templates', canActivate: [AuthGuardService], component: DashboardView,
        children: [
			// handle all other routes
            { path: '**', component: EmailTemplatesListComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(EmailTemplatesRouting)],
    exports: [RouterModule]
})
export class EmailTemplatesRoutingModule { }
